"use client";

import * as React from "react";
import { ArrowUp } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const socialLinks = [{
  name: "Instagram",
  url: "https://www.instagram.com/skinnbonezchicago/"
}, {
  name: "Facebook",
  url: "https://www.facebook.com/SkinNBonezChicago"
}];
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  return <section data-section-id="175655" id="footer" className="bg-[#000000] border-t border-white/10 py-8 px-4 md:px-8">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
        {}
        <div className="text-[14px] font-sans text-[#CCCCCC] text-center md:text-left">Copyright © 2026 SKIN N' BONEZ CHICAGO - All Rights Reserved.</div>

        {}
        <div className="flex justify-center gap-8 text-[14px] font-bold uppercase tracking-widest text-white font-sans">
          {socialLinks.map((link, i) => <Link key={link.name} to={link.url} data-index={i} className="hover:text-[#FF0000] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF0000]">
              {link.name}
            </Link>)}
        </div>

        {}
        <div className="flex justify-center md:justify-end">
          <Button variant="ghost" onClick={scrollToTop} className="uppercase font-bold text-[14px] tracking-widest text-white hover:bg-transparent hover:text-[#FF0000] transition-colors p-0 h-auto rounded-none font-sans">
            BACK TO TOP <ArrowUp className="w-4 h-4 ml-2" />
          </Button>
        </div>
      </div>
    </section>;
}
function StagePlotSection() {
  const [image, setImage] = React.useState<string | null>(null);
  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);
    }
  };
  return <section className="bg-[#000000] border-t border-white/10 py-16 px-4 md:px-8">
      <div className="max-w-5xl mx-auto text-center">
        
        {/* Title */}
        <h2 className="text-[42px] font-serif text-white mb-6">
          Stage Plot – Full Band
        </h2>

        {/* Description */}
        <p className="text-[16px] text-[#CCCCCC] mb-10">
          Technical layout for our live setup. Download or view below.
        </p>

        {/* Upload button (for testing / admin use) */}
        <div className="mb-8">
          <input type="file" accept="image/*" onChange={handleUpload} className="text-white" />
        </div>

        {/* Image Preview */}
        {image ? <div className="w-full flex justify-center">
            <img src={image} alt="Stage Plot Full Band" className="max-w-full h-auto rounded shadow-lg" />
          </div> : <div className="text-[#777777]">
            Upload your stage plot image to display it here
          </div>}
      </div>
    </section>;
}